import { t } from '@lingui/core/macro';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';

type Props = {
  supportEmail: string;
};

/** Customer service of the booking's own department, one tap from an email. */
export const BSlugSupportCard = ({ supportEmail }: Props) => (
  <NoddiBasicCard
    className='flex items-center justify-between gap-3 px-4 py-3'
    onClick={() => {
      window.location.href = `mailto:${supportEmail}`;
    }}
  >
    <div className='flex min-w-0 items-center gap-3'>
      <NoddiIcon name='Mail' size='small' className='shrink-0' />
      <div className='flex min-w-0 flex-col'>
        <p className='text-sm font-semibold'>{t`Questions about your booking?`}</p>
        <p className='truncate text-sm text-muted-foreground'>{t`Email us at ${supportEmail}`}</p>
      </div>
    </div>
    <NoddiIcon name='ChevronRight' size='xSmall' className='shrink-0' />
  </NoddiBasicCard>
);
